@use "../../../styles/userColors" as colors;
@use "./utils/json";

:export {
  baseUserColors: json.json-stringify(colors.$base-user-colors);
  selectedUserColors: json.json-stringify(colors.$selected-user-colors);
}
